import { render } from "./UsersPage.vue?vue&type=template&id=72b29b60&ts=true"
import script from "./UsersPage.ts?vue&type=script&lang=ts"
export * from "./UsersPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__